<template>
    <div class="about">
        <v-header />
        <v-sidebar />
        <div class="content-box" >
            <div class="content">
                <div>
                    <div class="crumbs">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item>
                                <i class="el-icon-paperclip"></i> {{query.cshow=='0'?'回收站':'评论管理'}}(共 {{pageTotal}} 条）
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <div class="container">
                        <div class="handle-box">
                            <el-input v-model="query.id" placeholder="评论id" class="handle-input mr10"></el-input>
                            <el-input v-model="query.hfId" placeholder="被回复的评论id" class="handle-input mr10"></el-input>
                            <el-input v-model="query.ftitle" placeholder="帖子标题" class="handle-input mr10"></el-input>
                            <el-input v-model="query.cont" placeholder="评论内容" class="handle-input mr10"></el-input>
                            <el-select v-model="query.typeId" placeholder="请选择" filterable>
                                <el-option label="请选择板块" ></el-option>
                                <el-option
                                        v-for="item in typelist"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <el-input v-model="query.uname" placeholder="评论者的用户名" class="handle-input mr10"></el-input>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                            <el-button type="danger" v-if="query.cshow=='1'&&lander.role=='100'"  @click="handleTrash">回收站 {{trashNum}}</el-button>
                            <el-button type="success" v-if="query.cshow=='0'&&lander.role=='100'"  @click="handleManage">评论管理</el-button>
                        </div>
                        <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header" size="mini">
                            <el-table-column prop="id" label="ID" width="100" align="center" fixed="left"></el-table-column>
                            <el-table-column  label="评论内容"  align="center"  fixed="left" width="200">
                                <template #default="scope">
                                    <div v-html="scope.row.cont"></div>
                                    <el-tag v-if="scope.row.cshow=='0' " type="danger">已在回收站</el-tag>
                                    <span v-else>

                                        <el-tooltip  v-if="scope.row.istop=='1'" class="item" effect="dark" :content="scope.row.topStart+'到'+scope.row.topEnd" placement="top-start">
                                        <el-tag  type="success">置顶</el-tag>
                                        </el-tooltip>

                                        <el-tooltip v-if="scope.row.istop=='0'&&scope.row.topStart!='0'" class="item" effect="dark" :content="scope.row.topStart+'到'+scope.row.topEnd" placement="top-start">
                                        <el-tag >将置顶</el-tag>
                                        </el-tooltip>
                                    </span>
                                </template>
                            </el-table-column>

                            <el-table-column label="状态"  align="center" width="200">
                                <template #default="scope">
                                    <p v-if="scope.row.cshow=='0'"  style="font-size: 12px;background: #f4f4f4;">管理员删除
                                        <span v-if="scope.row.delMsg!=null&&scope.row.delMsg.length>0"> <br>原因：{{scope.row.delMsg}}</span>
                                        <span v-if="scope.row.delTs!=null&&scope.row.delTs.length>0"> <br>时间：{{scope.row.delTs}}</span>

                                    </p>

                                    <el-tag v-if="scope.row.cshow=='1' ">正常显示</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="ftitle" label="帖子标题" width="200"  align="center">
                                <template #default="scope">
                                    <router-link :to="'ForumDetail?id='+scope.row.forumId+'&goPosition=top'" target="_blank">{{scope.row.ftitle}}</router-link>
                                </template>
                            </el-table-column>
                            <el-table-column prop="name" label="板块名称"  width="120"   align="center">
                                <template #default="scope">
                                    <router-link :to="'Forum?typeId='+scope.row.typeId" target="_blank">{{scope.row.name}}</router-link>
                                </template>
                            </el-table-column>
                            <el-table-column prop="uname" label="评论者"  align="center">
                                <template #default="scope">
                                    <router-link :to="'Home?type=myforum&authorId='+scope.row.commentUid" target="_blank">{{scope.row.uname}}</router-link>
                                </template>
                            </el-table-column>

                            <el-table-column prop="hitNum" label="点赞量"  align="center"></el-table-column>
                            <el-table-column prop="replayNum" label="回复量量"  align="center"></el-table-column>

                            <el-table-column prop="hfId" label="回复id" width="100" align="center"></el-table-column>
                            <el-table-column prop="cts" label="创建时间" width="180" align="center"></el-table-column>


                            <el-table-column label="操作" width="120" align="center" fixed="right">
                                <template #default="scope">


                                    <el-dropdown>
                                        <el-button type="primary">
                                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item  v-if="scope.row.cshow=='1' ">
                                                <el-button type="text" icon="el-icon-top"
                                                           @click="handleTopbest(scope.$index, scope.row,'top')">置顶
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item v-if="scope.row.topStart!='0'&&scope.row.cshow=='1' ">
                                                <el-button type="text" icon="el-icon-close"
                                                           @click="handleCancelTopbest(scope.$index, scope.row,'top')">取消置顶
                                                </el-button>
                                            </el-dropdown-item>


                                            <el-dropdown-item  v-if="scope.row.cshow=='1'  ">
                                                <el-button type="text" icon="el-icon-delete" class="red"
                                                           @click="handleDelete(scope.$index, scope.row)">删除
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item  v-if="scope.row.cshow=='0' && lander.role=='100'">
                                                <el-button type="text" icon="el-icon-check"
                                                           @click="handleShow(scope.$index, scope.row)">恢复
                                                </el-button>
                                            </el-dropdown-item>

                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                    background
                                    @size-change="handleSizeChange"
                                    @current-change="handlePageChange"
                                    :current-page="query.pageNo"
                                    :page-sizes="[10,20,30]"
                                    :page-size="query.pageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="pageTotal">
                            </el-pagination>
                        </div>
                    </div>


                </div>
            </div>
        </div>


        <!--置顶,收录 -->
        <el-dialog :title="  '设置置顶'+ topData.cont " :visible.sync="topbestVisible">
            <el-form
                    label-width="120px"
                    :model="topData"
                    :rules="topDataRule"
                    ref="topData"
            >
                <el-form-item label="开始时间" prop="start">
                    <el-date-picker
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            v-model="topData.start"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="end">
                    <el-date-picker
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            v-model="topData.end"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>

            <template #footer>


                    <span class="dialog-footer">
                        <el-button @click="topbestVisible = false">取 消</el-button>
                        <el-button type="primary" @click="saveTopbestHnadle">确 定</el-button>
                    </span>
            </template>
        </el-dialog>

        <!--删除 -->
        <el-dialog :title=" ' 删除-'+ delData.ftitle " :visible.sync="delVisible">
                <p>请输入删除的原因</p>
                 <el-input  v-model="delData.delMsg" type="textarea"/>
                 <p>  <el-tag v-for="(t,i) in delMsgli" @click="delData.delMsg=t" :key="i">{{t}}</el-tag></p>

                 <p class="red" v-if="delData.replayNum>0&&delData.hfId==0">该评论下有 {{delData.replayNum}} 条回复，删除该评论后它以下回复也会被删除，谨慎删除</p>

            <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="delVisible = false">取 消</el-button>
                        <el-button type="primary" @click="suredel">确定删除</el-button>
                    </span>
            </template>
        </el-dialog>



    </div>
</template>

<script>
    import vHeader from "./Header.vue";
    import vSidebar from "./Sidebar.vue";
    import {
        admin_comment_page,
        admin_comment_del,
        getTypeForumList,
        admin_comment_getTrashNum,
        admin_comment_saveTop,
        admin_comment_showNormal,
        admin_users_type_seeTypes
    } from '../../api';
    import {dealResult} from "../../api/common";
    export default {
        name: "AdminComment",
        components: {
            vHeader,
            vSidebar,
        },
        data() {
            const confirmEndDate = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === ""|| str === "0") {
                    callback("请输入结束时间");
                }   else if (str < this.topData.start) {
                    callback('结束时间错误!');
                } else {
                    callback();
                }
            };
            return {
                delMsgli:["广告","心术不正","言词不雅"],
                delVisible:false,
                delData: {},

                moveVisible:false,
                moveData: {
                    id:'',
                    typeId:'',
                    ftitle:'',
                },


                lander:{},
                trashNum:0,
                typelist:[],
                tableData: [],
                query :{
                    id:'',
                    hfId:'',
                    uname: '',
                    ftitle: '',
                    typeId: '',
                    pageNo: 1,
                    pageSize: 10,
                    cshow:'1',
                },
                pageTotal: 0,


                topbestVisible: false,
                topData :{
                    id :'',
                    start : '',
                    end : '',
                },
                topDataRule: {
                    start: [{required: true, message: '不能为空', trigger: 'blur'}],
                    end: [{required: true, message: '不能为空', trigger: 'blur'},
                    {validator: confirmEndDate, trigger: ["change", "blur"]}],
                },
            };
        },
        methods:{


            handleCancelTopbest(index,row,type){
                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    type:type,
                    start:'0',
                    end:'0',
                    id:row.id,
                }

                // 二次确认
                this.$confirm("确定取消【"+row.ftitle+"】的置顶？ ", "提示", {
                    type: "warning",
                }) .then(() => {
                        this.saveTopBest(o);

                });



            },
            handleTopbest(index,row,type){
                this.topbestVisible=true;
                this.topData.ftitle=row.ftitle;
                this.topData.id=row.id;
                this.topData.end='';
                this.topData.start='';
                this.topData.type=type;

                if(type=='top'){
                    if(row.topStart!='0')this.topData.start=row.topStart;
                    if(row.topEnd!='0')this.topData.end=row.topEnd;
                }
                if(type=='best'){
                    if(row.bestStart!='0')this.topData.start=row.bestStart;
                    if(row.bestEnd!='0')this.topData.end=row.bestEnd;
                }
            },
            //保存操作
            saveTopbestHnadle(){
                this.$refs.topData.validate(valid => {
                    //表单验证失败
                    if (!valid) {
                        //提示语
                        this.$message.error("请按提示填写表单");
                        //this.topbestVisible = true;
                        return false;
                    } else {
                        let o={  uid:this.lander.uid,
                            token:this.lander.token,
                            type:this.topData.type,
                            start:this.topData.start,
                            end:this.topData.end,
                            id:this.topData.id,
                        }
                        this.saveTopBest(o);
                    }
                })
            },
            saveTopBest(o){
                admin_comment_saveTop(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.$message.success(res.data.msg)
                        this.topbestVisible = false;
                        this.getPage();
                    }  else {
                        this.$message.error(res.data.msg)
                    }

                })
            },
            handleManage(){
                this.tableData=[];
                this.query.id='';
                this.query.hfId='';
                this.query.cshow='1';
                this.query.uname='';
                this.query.typeId='';
                this.query.pageNo = 1;
                this.getPage();
            },
            handleTrash(){
                this.tableData=[];
                this.query.id='';
                this.query.hfId='';
                this.query.cshow='0';
                this.query.uname='';
                this.query.typeId='';
                this.query.pageNo = 1;
                this.getPage();
            },
            // 查询操作
            handleSearch (){

                this.query.pageNo = 1;
                this.getPage();
            },

            // 分页导航
            handlePageChange (val) {
                this.query.pageNo = val;
                this.getPage();
            },
            handleSizeChange(val) {
                this.query.pageNo = 1;
                this.query.pageSize = val;
                this.getPage();
            },

            handleShow(index,row){
                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    id:row.id,
                    forumId:row.forumId,
                }

                // 二次确认
                this.$confirm("确定恢复【"+row.ftitle+"】？"  , "提示", {
                    type: "warning",
                }) .then(() => {

                    admin_comment_showNormal(o).then((res) => {
                        dealResult(res.data);
                        if (res.data.status == 1  ) {
                            this.$message.success(res.data.msg)
                            this.getPage();
                            this.getTrashNum();
                        }  else {
                            this.$message.error(res.data.msg)
                        }

                    })

                });
            },



            //删除操作
            handleDelete(index,row){
                 this.delVisible=true;
                 this.delData =row ;
            },

            suredel(){
                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    type:this.topData.type,
                    id:this.delData.id,
                    delMsg:this.delData.delMsg,
                    forumId:this.delData.forumId,
                }
                admin_comment_del(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.delVisible=false;
                        this.$message.success(res.data.msg);
                        this.getPage();
                        this.getTrashNum();
                    }  else {
                        this.$message.error(res.data.msg)
                    }

                })
            },

            //获取列表数据
            getPage(){
                this.query.uid=this.lander.uid;
                this.query.token=this.lander.token;
                admin_comment_page(this.query).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.tableData = res.data.obj.list
                        this.pageTotal = res.data.obj.total//该页总共多少条记录

                    }  else {
                        this.$message.error(res.data.msg)
                    }

                })
            },
            //回收站数量
            getTrashNum(){
                let o={  uid:this.lander.uid, token:this.lander.token,cshow:'0'}
                admin_comment_getTrashNum(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.trashNum = res.data.obj;
                    }  else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //获取分类列表数据
            getTypeList(){
                let o={  uid:this.lander.uid, token:this.lander.token}
                getTypeForumList(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                         this.typelist = res.data.obj;
                    }  else {
                        this.$message.error(res.data.msg)
                    }
                });

            },
            //获取调研组员的分类
            getManageTyeLi() {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    manageUid: this.lander.uid
                }
                admin_users_type_seeTypes(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        let li=res.data.obj;
                        this.typelist=[];
                        for(let i=0;i<li.length;i++){
                            let forumobj={id:li[i].typeId,name:li[i].name};
                            this.typelist.push(forumobj);
                        }


                    }

                })
            },

        },
        mounted() {
            this.lander = JSON.parse(this.$store.state.logininfo);
            //去后端查询所有的用户给tableData赋值
            this.getPage();
            if( this.lander.role=='100'){
                this.getTypeList();
                this.getTrashNum();
            }
            if( this.lander.role=='50'){
                this.getManageTyeLi() ;
            }

        }
    }
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .table {
        width: 100%;
        font-size: 14px;
    }
    .red {
        color: #ff0000;
    }
    .mr10 {
        margin-right: 10px;
        width: 150px;
    }
    /*滚动条的宽度*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 10px;
    }
    /*滚动条滑块*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background-color: #409eff;
        /*border-radius: 3px;*/
    }
</style>
